// livr errors formatter
var formatter = function formatter() {
  var errorsObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var paramsObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var outputObj = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var errorsArr = Object.entries(errorsObj).map(function (error) {
    return error.join(': ');
  });
  var paramsArr = Object.entries(paramsObj).map(function (error) {
    return error.join(': ');
  });
  var outputArr = Object.entries(outputObj).map(function (error) {
    return error.join(': ');
  });
  return "\nValidation errors:\n".concat(errorsArr.join('\n'), "\n\n  With params: \n ").concat(paramsArr.join('\n'), "\n\n  Which output: \n ").concat(outputArr.join('\n'));
};

export default formatter;
